<template>
  <div v-if="isLayerShow && zoom > zoomIconHide">
    <l-marker
      v-for="obs in observatories"
      :key="obs.id"
      :lat-lng="[obs.lat, obs.lng]"
    >
      <l-icon
        v-if="!obs.speed || obs.direction === 0"
        :icon-size="[12, 12]"
        :icon-anchor="[6, 6]"
      >
        <v-icon class="outlined" color="#b9ebfa" x-small>
          mdi-circle
        </v-icon>
      </l-icon>
      <l-icon v-else :icon-size="[24, 24]" :icon-anchor="windIconAnchor">
        <v-icon
          :style="`transform: rotate(${(360 / 16) * obs.direction - 180}deg)`"
          :color="getWindColor(obs.speed)"
          class="outlined"
        >
          mdi-navigation
        </v-icon>
      </l-icon>
    </l-marker>
  </div>
</template>
<script>
import { LIcon, LMarker } from "vue2-leaflet";
import { OBSERVATORY } from "@/enums/Type";
export default {
  name: "ObservatoryWindLayer",
  components: {
    LIcon,
    LMarker
  },
  computed: {
    observatories() {
      const observatories = this.$store.getters.observatories;
      return observatories.filter(obs => {
        return obs.type === OBSERVATORY.WIND.code;
      });
    },
    riskSubControl() {
      return this.$store.getters.riskSubControl;
    },
    isLayerShow() {
      if (this.observatories.length === 0) {
        return false;
      }
      return this.riskSubControl.observatory.includes(OBSERVATORY.WIND.code);
    },
    windIconAnchor() {
      return this.riskSubControl.observatory.includes(OBSERVATORY.RAIN.code)
        ? [12, -6]
        : [12, 12];
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    zoom() {
      return Math.floor(this.map.getZoom());
    },
    isMobile() {
      return this.$route.path === "/mobile";
    },
    zoomIconHide() {
      return this.isMobile ? 9 : 8;
    }
  },
  watch: {
    //
  },
  methods: {
    getWindColor(speed) {
      const value = speed;
      const colors = [
        { color: "#b40068", value: 25 },
        { color: "#f12705", value: 20 },
        { color: "#f49904", value: 15 },
        { color: "#f9f503", value: 10 },
        { color: "#3e42ff", value: 5 },
        { color: "#b9ebfa", value: 0 }
      ];

      let current;
      for (const color of colors) {
        if (color.value <= value) {
          current = color.color;
          break;
        }
      }
      return current;
    }
  }
};
</script>
<style>
.v-icon.outlined {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
</style>
